// AUTO-GENERATED by scripts/build-registry.js: study entry for navigation/vor-characteristics.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/navigation/vor-characteristics/vor-characteristics.js';

mount([g0]);
